<template>
  <div class="module-error">
    <div class="module-error__message-wrapper">
      <NebulaIcon
        class="module-error__warning-icon"
        symbol-id="warning"
        size="l"
      />
      <span class="module-error__message">{{ message }}</span>
    </div>
    <span class="module-error__submessage">{{ submessage }}</span>
  </div>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';
import i18next from '@/lib/i18next';

export default {
  name: 'ModuleError',
  components: {
    NebulaIcon,
  },
  props: {
    assetId: {
      type: String,
      default: null,
    },
    error: {
      type: Object,
      default() {
        return {
          message: i18next.t('An error occurred.'),
        };
      },
    },
  },
  computed: {
    message() {
      if (this.error.status_code === 404) {
        return this.$t('Asset cannot be found.');
      }

      return this.error.message;
    },
    submessage() {
      if (this.error.status_code === 404) {
        return this.assetId;
      }

      return null;
    },
  },
};
</script>

<style lang="stylus">
.module-error {
  align-items: center;
  background-color: $nebula-color-interface-blue-600;
  border-radius: 6px; // match standard canvas module radius
  bottom: 0;
  color: $nebula-color-white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: $nebula-space-2x;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;

  &__warning-icon {
    fill: $nebula-color-white;
    flex-shrink: 0;
    margin-right: $nebula-space-1x;
  }

  &__message-wrapper {
    align-items: center;
    display: flex;
    margin: $nebula-space-2x 0 $nebula-space-1x;
  }

  &__message {
    nebula-text-body-1();
    color: $nebula-color-white;
    font-weight: 600;
    text-align: left;
  }

  &__submessage {
    nebula-text-caption();
    color: $nebula-color-white;
    opacity: .6;
  }
}
</style>
